import React, { lazy, useEffect } from "react";
import { I18n } from "react-redux-i18n";
import { BrowserRouter, Route, Routes } from "react-router-dom";

// Layout persistente
import PersistentLayout from "app/layouts/PersistentLayout.jsx";
// Lazy loading para componentes de autenticação (críticos - carregados imediatamente)
import Error from "containers/error/Error.jsx";
import Login from "containers/login/Login.jsx";
import PasswordRecovery from "containers/password/passwordRecovery/PasswordRecovery.jsx";
import PasswordRecoveryCode from "containers/password/passwordRecoveryCode/PasswordRecoveryCode.jsx";

import Public from "./Public.jsx";

// Lazy loading para componentes do painel (carregados sob demanda)

const CitiesBlockList = lazy(
  () => import("containers/panel/block-list/CitiesBlockList.jsx")
);
const ClientsBlockList = lazy(
  () => import("containers/panel/block-list/ClientsBlockList.jsx")
);
const CityBlockListForm = lazy(
  () => import("containers/panel/city-block-list-form/CityBlockListForm.jsx")
);
const ClientBlockListForm = lazy(
  () =>
    import("containers/panel/client-block-list-form/ClientBlockListForm.jsx")
);
const ClientDetail = lazy(
  () => import("containers/panel/client/client-detail/ClientDetail.jsx")
);
const Client = lazy(() => import("containers/panel/client/Client.jsx"));
const Complaint = lazy(
  () => import("containers/panel/client/complaint/Complaint.jsx")
);
const ContractConsolidated = lazy(
  () =>
    import("containers/panel/contract-consolidated/ContractConsolidated.jsx")
);
const ContractDetail = lazy(
  () => import("containers/panel/contract/contract-detail/ContractDetail.jsx")
);
const Contract = lazy(() => import("containers/panel/contract/Contract.jsx"));
const DistributorDetail = lazy(
  () =>
    import(
      "containers/panel/distributor/distributor-detail/DistributorDetail.jsx"
    )
);
const Distributor = lazy(
  () => import("containers/panel/distributor/Distributor.jsx")
);
const Installment = lazy(
  () => import("containers/panel/installment/Installment.jsx")
);
const PreContractConsolidated = lazy(
  () =>
    import(
      "containers/panel/pre-contract-consolidated/PreContractConsolidated.jsx"
    )
);
const PreContract = lazy(
  () => import("containers/panel/pre-contract/PreContract.jsx")
);
const ReportDownloads = lazy(
  () => import("containers/panel/report-downloads/ReportDownloads.jsx")
);
const UserPartnerDetail = lazy(
  () =>
    import(
      "containers/panel/user-partner/user-partner-detail/UserPartnerDetail.jsx"
    )
);
const UserPartner = lazy(
  () => import("containers/panel/user-partner/UserPartner.jsx")
);

// paymeny
const Payment = lazy(() => import("containers/panel/payment/Payment.jsx"));

// invoice compensation
const InvoiceCompensation = lazy(
  () => import("containers/panel/invoice-compensation/InvoiceCompensation.jsx")
);

// billet
const Billet = lazy(() => import("containers/panel/billet/Billet.jsx"));

// receivables anticipation
const ReceivablesAnticipation = lazy(
  () =>
    import(
      "containers/panel/receivables-anticipation/ReceivablesAnticipation.jsx"
    )
);

const PublicRoute = ({ title, container, ...props }) => (
  <Public title={title} container={container} {...props} />
);

const PageTitle = ({ title, children }) => {
  useEffect(() => {
    document.title = title || "CPFL Finergy";
  }, [title]);
  return <>{children}</>;
};

class Content extends React.PureComponent {
  render() {
    return (
      <BrowserRouter>
        <Routes>
          {/* Rotas públicas (sem layout persistente) */}
          {/* <Route
            path={I18n.t("routes.authAssertion.url")}
            element={
              <PublicRoute
                container={<AuthAssertion />}
                title={`${I18n.t("routes.authAssertion.pageTitle")} - ${I18n.t("application.name")}`}
              />
            }
          /> */}
          <Route
            path={I18n.t("routes.login.url")}
            element={
              <PublicRoute
                container={<Login />}
                title={`${I18n.t("routes.login.pageTitle")} - ${I18n.t("application.name")}`}
              />
            }
          />

          <Route
            path={I18n.t("routes.passwordRecovery.url")}
            element={
              <PublicRoute
                container={<PasswordRecovery />}
                title={`${I18n.t("routes.passwordRecovery.pageTitle")} - ${I18n.t("application.name")}`}
              />
            }
          />

          <Route
            path={I18n.t("routes.passwordRecoveryCode.url")}
            element={
              <PublicRoute
                container={<PasswordRecoveryCode />}
                title={`${I18n.t("routes.passwordRecoveryCode.pageTitle")} - ${I18n.t("application.name")}`}
              />
            }
          />

          {/* Rotas autenticadas com layout persistente */}
          <Route path="/*" element={<PersistentLayout />}>
            <Route
              path="distributor"
              element={
                <PageTitle
                  title={`${I18n.t("routes.distributor.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <Distributor />
                </PageTitle>
              }
            />
            <Route
              path="distributor/:id"
              element={
                <PageTitle
                  title={`${I18n.t("routes.distributorDetail.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <DistributorDetail />
                </PageTitle>
              }
            />
            <Route
              path="userPartner"
              element={
                <PageTitle
                  title={`${I18n.t("routes.userPartner.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <UserPartner />
                </PageTitle>
              }
            />
            <Route
              path="userPartner/:id"
              element={
                <PageTitle
                  title={`${I18n.t("routes.userPartnerDetail.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <UserPartnerDetail />
                </PageTitle>
              }
            />
            <Route
              path="installment"
              element={
                <PageTitle
                  title={`${I18n.t("routes.installment.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <Installment />
                </PageTitle>
              }
            />
            <Route
              path="contract"
              element={
                <PageTitle
                  title={`${I18n.t("routes.contract.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <Contract />
                </PageTitle>
              }
            />
            <Route
              path="consolidated/contract"
              element={
                <PageTitle
                  title={`${I18n.t("routes.contractConsolidated.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <ContractConsolidated />
                </PageTitle>
              }
            />
            <Route
              path="contract/:id"
              element={
                <PageTitle
                  title={`${I18n.t("routes.contractDetail.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <ContractDetail />
                </PageTitle>
              }
            />
            <Route
              path="consolidated/pre-contract"
              element={
                <PageTitle
                  title={`${I18n.t("routes.preContractConsolidated.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <PreContractConsolidated />
                </PageTitle>
              }
            />
            <Route
              path="pre-contract"
              element={
                <PageTitle
                  title={`${I18n.t("routes.preContract.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <PreContract />
                </PageTitle>
              }
            />
            <Route
              path="client"
              element={
                <PageTitle
                  title={`${I18n.t("routes.client.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <Client />
                </PageTitle>
              }
            />
            <Route
              path="block-list/users"
              element={
                <PageTitle
                  title={`${I18n.t("routes.clientsBlockList.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <ClientsBlockList />
                </PageTitle>
              }
            />
            <Route
              path="block-list/users/:id"
              element={
                <PageTitle
                  title={`${I18n.t("routes.clientBlockListForm.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <ClientBlockListForm />
                </PageTitle>
              }
            />
            <Route
              path="block-list/cities"
              element={
                <PageTitle
                  title={`${I18n.t("routes.citiesBlockList.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <CitiesBlockList />
                </PageTitle>
              }
            />
            <Route
              path="block-list/cities/:id"
              element={
                <PageTitle
                  title={`${I18n.t("routes.cityBlockListForm.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <CityBlockListForm />
                </PageTitle>
              }
            />
            <Route
              path="client/:id"
              element={
                <PageTitle
                  title={`${I18n.t("routes.clientDetail.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <ClientDetail />
                </PageTitle>
              }
            />
            <Route
              path="client/:id/complaint/new"
              element={
                <PageTitle
                  title={`${I18n.t("routes.clientNewComplaint.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <Complaint />
                </PageTitle>
              }
            />
            <Route
              path="client/:id/complaint/:complaintId/edit"
              element={
                <PageTitle
                  title={`${I18n.t("routes.clientEditComplaint.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <Complaint />
                </PageTitle>
              }
            />
            <Route
              path="payment"
              element={
                <PageTitle
                  title={`${I18n.t("routes.payment.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <Payment />
                </PageTitle>
              }
            />
            <Route
              path="payment/invoice-compensation"
              element={
                <PageTitle
                  title={`${I18n.t("routes.invoiceCompensation.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <InvoiceCompensation />
                </PageTitle>
              }
            />
            <Route
              path="billet"
              element={
                <PageTitle
                  title={`${I18n.t("routes.billet.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <Billet />
                </PageTitle>
              }
            />
            <Route
              path="contract/receivables-anticipation"
              element={
                <PageTitle
                  title={`${I18n.t("routes.receivablesAnticipation.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <ReceivablesAnticipation />
                </PageTitle>
              }
            />
            <Route
              path="report-downloads"
              element={
                <PageTitle
                  title={`${I18n.t("routes.reportDownloads.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <ReportDownloads />
                </PageTitle>
              }
            />
            <Route
              path="report-downloads"
              element={
                <PageTitle
                  title={`${I18n.t("routes.reportDownloads.pageTitle")} - ${I18n.t("application.name")}`}
                >
                  <ReportDownloads />
                </PageTitle>
              }
            />
            <Route
              path="*"
              element={
                <PublicRoute
                  container={<Error />}
                  title={`${I18n.t("routes.error.pageTitle")} - ${I18n.t("application.name")}`}
                />
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    );
  }
}

export default Content;
